import React from 'react'
import { hooks } from '@front/volcanion'
import { HookUtils } from '@front/volcanion/utils/'

import { Loader } from '@front/squirtle'

const withContainer = Component => props => {
  const [selectedCompany, setSelectedCompany] = hooks.useGlobalState('persist.selectedCompany')
  const [user] = hooks.useActiveUser()
  const [company_users, , company_users_state] = hooks.useModelSearch('companyuser', 'get', {
    initial_filter: { user: user?.user_id, status: ['active'], administration_level: { '!': null } },
    forced_filter: { user: user?.user_id, status: ['active'], administration_level: { '!': null } },
    watchers: [user?.user_id],
    populate: ['company']
  })

  const ids = _.map(company_users, 'company.company_id')
  const hasMultiple = _.size(ids) > 1

  const mergedProps = {
    ids,
    hasMultiple,
    selectedCompany,
    setSelectedCompany
  }

  const isLoading = HookUtils.getLoadingState(company_users_state) || !!selectedCompany && _.isEmpty(company_users)
  return (
    <Loader isLoading={isLoading} size={20}>
      <Component {...mergedProps} />
    </Loader>
  )
}

export default withContainer
